// Action Types
export const FETCH_WIN_OPPORTUNITIES_REQUEST = "FETCH_WIN_OPPORTUNITIES_REQUEST";
export const FETCH_WIN_OPPORTUNITIES_SUCCESS = "FETCH_WIN_OPPORTUNITIES_SUCCESS";
export const FETCH_WIN_OPPORTUNITIES_FAILURE = "FETCH_WIN_OPPORTUNITIES_FAILURE";

// Action Creators
export const fetchWinOpportunitiesRequest = ({ clientName,accountName,userId,type}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_WIN_OPPORTUNITIES_REQUEST,
      payload: { clientName,accountName,userId,type },
    });
  };
};
export const fetchWinOpportunitiesSuccess = (data) => ({
  type: FETCH_WIN_OPPORTUNITIES_SUCCESS,
  payload: data,
});
export const fetchWinOpportunitiesFailure = (error) => ({
  type: FETCH_WIN_OPPORTUNITIES_FAILURE,
  payload: error,
});
